

















































































































































































import BookingAllowance from "@/components/customers/booking-allowance.vue";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { Customer } from "@/swagger/models";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { subject } from "@casl/ability";
import { customerService } from "@/services/customer";
import TabsSettings from "@/components/tabs/settings.vue";
import { Watch } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "customer",
    components: { BookingAllowance, TabsSettings, PageHeader, Card, CommitResetBar, Page },
})
export default class CustomerView extends Vue {
    committable: Committable<Customer>;

    // nextId: number = null;
    // previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<Customer>({
                onCommit: WrapService(customerService, {
                    // Todo: use proper DTO and get this committable from the service directly
                    patchFields: [
                        "oktaGroupId",
                        "name",
                        "address",
                        "postalCode",
                        "city",
                        "province",
                        "country",
                        "maxReservations",
                    ],
                    routeIdParam: "customerId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.customerId === "new") {
                this.committable.set(customerService.build());
            } else {
                const res = await customerService.getNew(parseInt(this.$route.params.customerId));
                this.committable.set(res.data);
                // this.previousId = res.previousId;
                // this.nextId = res.nextId;
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.customerId === "new" && this.$can("create", "Customer")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Customer", this.committable?.original?.value))) return true;
        return false;
    }
}
